(function(){
    'use strict';

    angular
    .module('appback')
    .controller('InclinicController', InclinicController)
 
    InclinicController.$inject = ["$http","$timeout","$uibModal", "$log", "$document","$sce"];
              
    function InclinicController($http,$timeout,$uibModal, $log, $document,$sce)
    {                         
        var vm = this;
        
    }
  
})();